import React from 'react';
import Slider from '../components/Slider'
import Gallery from '../components/Gallery'

const Home = () => {
  return (
    <div>
      <Slider />
      <div>
        <div className="home__wrap">
          <div className="home_title">Speaker/ Coach</div>
        </div>
        <hr style={{margin: 0}} />
        <div className="home__wrap">
          <Gallery />
        </div>
      </div>
      <div>
        <div className="home__wrap">
          <div className="home_title">Event Details</div>
        </div>
        <hr style={{margin: 0}} />
        <div className="home__wrap">
          <div className="home_title">Details:</div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.  Duis aute irure dolor 
in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
officia deserunt mollit anim id est laborum.</p>
        </div>
        <div className="home__wrap">
        <div className="home_title">Requirements:</div>
          <p className="home__p">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.  Duis aute irure dolor 
in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
officia deserunt mollit anim id est laborum.</p>
        </div>
      </div>
    </div>
  );
}
export default Home;
